// extracted by mini-css-extract-plugin
module.exports = {"menuPanel":"v5VindS7egMMQpUNBiBQXA==","subtitle":"R0puYDKhXiqw+SwGfNnUzw=="};